import { render, staticRenderFns } from "./generic-error.vue?vue&type=template&id=642661e0&"
import script from "./generic-error.vue?vue&type=script&lang=js&"
export * from "./generic-error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports